<ng-container *ngIf="data$ | async as data">
	<div
		class="d-flex justify-content-center align-items-center w-100"
		style="height: 500px"
		*ngIf="!data.length; else dataLoaded"
	>
		<mat-spinner></mat-spinner>
	</div>
	<ng-template #dataLoaded>
		<h3>{{ data[0].subject }}</h3>
		<div
			class="overflow-auto px-1"
			[ngClass]="{
				'max-h-500': !showAnswer && dialogData,
				'max-h-200': showAnswer && dialogData,
			}"
		>
			<div class="border-bottom pb-2 my-2" *ngFor="let message of data; let isLast = last; let i = index">
				<div class="message-all">
					<div
						(click)="message.show = !message.show"
						class="d-flex justify-content-between cursor-pointer align-items-center w-100 message"
					>
						<span>{{ message.sender }}<br /></span>
						<span>{{ message.date | date: 'dd.MM.yyyy, HH:mm' }}</span>
					</div>
					<div *ngIf="message.show || isLast" class="message-details">
						<div style="font-size: 12px; width: fit-content">
							<span class="text-secondary me-1">do {{ message.addressee }}</span>
							<i
								(click)="openDetailsDialog(details, message)"
								#details
								matTooltip="Pokaż szczegóły"
								matTooltipPosition="below"
								class="fas fa-caret-down cursor-pointer details"
							></i>
						</div>
						<mat-card appearance="outlined">
							<mat-card-content class="pt-2">
								<iframe
									#messageIframe
									[height]="iframeDefaultHeight"
									[srcdoc]="removeGmailAnswers(message.body | decodeBase64)"
									width="100%"
								></iframe>
								<div class="w-100 text-center">
									<button
										mat-icon-button
										[title]="iframeConditionMap.get(i) ? 'Rozwiń' : 'Zwiń'"
										(click)="adjustIframeHeight(messageIframe, i)"
									>
										<i
											[class]="
												iframeConditionMap.get(i) ? 'fas fa-chevron-down' : 'fas fa-chevron-up'
											"
										></i>
									</button>
								</div>
							</mat-card-content>
							<div class="d-flex justify-content-end">
								<button
									*ngIf="attachmentsList[i]?.length && !isAttachmentsShow(i)"
									class="attachmentButton"
									mat-raised-button
									color="primary"
									(click)="getAttachmentsList(i, message)"
								>
									Pokaż załączniki
								</button>
								<button
									*ngIf="isAttachmentsShow(i)"
									class="me-1"
									mat-mini-fab
									color="primary"
									matTooltip="Ukryj załączniki"
									(click)="hideAttachmentList(i)"
									aria-label="Ukryj załączniki"
								>
									<i class="fas fa-eye-slash"></i>
								</button>
								<button
									*ngIf="isAttachmentsShow(i)"
									mat-mini-fab
									class="ms-1"
									color="primary"
									matTooltip="Pobierz wszystkie załączniki"
									(click)="downloadAllAttachments(i)"
									aria-label="Pobierz wszystkie załączniki"
								>
									<i class="fas fa-download"></i>
								</button>
							</div>
							<mat-progress-bar
								*ngIf="!isImagesLoaded[i]"
								mode="indeterminate"
								class="mt-4"
							></mat-progress-bar>
							<div
								*ngIf="attachmentsList[i]?.length"
								[ngClass]="{
									'd-none': !isImagesLoaded[i],
									'd-flex': isImagesLoaded[i],
								}"
								class="flex-wrap"
							>
								<ng-container
									*ngFor="let attachment of attachmentsList[i]; let attachmentIndex = index"
								>
									<div *ngIf="attachment.src" class="attachment me-3 mt-3">
										<img
											*ngIf="attachment.mimeType.includes('image'); else icon"
											class="background-icon"
											[alt]="attachment.filename"
											(load)="imageLoad(i)"
											[src]="attachment.src"
										/>
										<ng-template #icon>
											<i
												[ngClass]="setFileIconClass(attachment.mimeType)"
												class="fas file-icon"
											></i>
										</ng-template>
										<div class="attachment-content d-flex flex-column justify-content-between">
											<p
												class="cursor-pointer"
												(click)="
													reservationMessageGallery.openGallery(
														attachmentsList[i],
														attachmentIndex
													)
												"
											>
												{{ attachment.filename }}
											</p>
											<div class="text-center">
												<button
													matTooltip="Pobierz"
													class="btn btn-secondary downloadButton btn-sm mx-1"
													(click)="
														downloadService.downloadAttachment(
															attachmentsList[i][attachmentIndex]
														)
													"
												>
													<i class="fas fa-download"></i>
												</button>
												<button
													*ngIf="attachment.mimeType.includes('image')"
													matTooltip="Podgląd"
													(click)="
														reservationMessageGallery.openGallery(
															attachmentsList[i],
															attachmentIndex
														)
													"
													class="btn btn-secondary btn-sm mx-1"
												>
													<i class="fas fa-eye"></i>
												</button>
											</div>
										</div>
									</div>
								</ng-container>
							</div>
						</mat-card>
					</div>
				</div>
			</div>
		</div>
		<form *ngIf="showAnswer">
			<mat-card appearance="outlined">
				<app-reservation-message-send
					(closeAnswer)="closeAnswer()"
					[conversationId]="conversationId"
					[lastMessageId]="data[data.length - 1].id"
					[isAnswer]="true"
				></app-reservation-message-send>
			</mat-card>
		</form>
		<div class="mt-4 text-end">
			<button
				*ngIf="!showAnswer"
				(click)="showAnswer = true"
				class="answerButton"
				mat-raised-button
				color="primary"
			>
				Odpowiedz<i class="fas fa-reply ps-1"></i>
			</button>
		</div>
	</ng-template>
</ng-container>
<app-reservation-message-gallery [attachmentsList]="attachmentsList"></app-reservation-message-gallery>
